<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import type {ActionArray} from 'shared/utils/svelte-actions-utils';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';

    export let icon: UIcons;
    export let active = false;
    export let use: ActionArray = [];
    export let tooltipLabel: string;
</script>

<KpIconButton {icon}
              buttonStyle={active ? 'primary' : 'no-background'}
              on:click
              {tooltipLabel}
              {use}
              {...$$restProps}/>